module.exports = __webpack_public_path__ + "static/img/sun.f48e23e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sun.jpeg
// module id = xlm9
// module chunks = 1